import React from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import InterestedInUsedGMC from './InterestedInUsedGMC'

const Used2015MercedesBenzCla45ForSaleInBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="Used 2015 Mercedes-Benz CLA45 For Sale In Boerne & Austin, Texas at Mark Motors"
                description="The used 2015 Mercedes-Benz CLA45 AMG for sale in Boerne & Austin, Texas at Mark Motors sits at the top of its family of exceptional builds - the used 2015 Mercedes-Benz CLA45, CLA45 4MATIC, and CLA45 AMG - and brings you exceptional power, style, and technology."
                keywords="2015 Mercedes-Benz CLA45 AMG For Sale in Boerne & Austin, Texas | 2015 Mercedes-Benz CLA45 AMG Specials in Boerne & Austin, Texas | 2015 Mercedes-Benz CLA45 AMG Dealer in Boerne & Austin, Texas | 2015 Mercedes-Benz CLA45 AMG For Sale Near Boerne & Austin, Texas | 2015 Mercedes-Benz CLA45 AMG in Boerne & Austin TX"
                ogTitle="Used 2015 Mercedes-Benz CLA45 For Sale In Boerne & Austin, Texas at Mark Motors"
                ogDescription="The used 2015 Mercedes-Benz CLA45 AMG for sale in Boerne & Austin, Texas at Mark Motors sits at the top of its family of exceptional builds - the used 2015 Mercedes-Benz CLA45, CLA45 4MATIC, and CLA45 AMG - and brings you exceptional power, style, and technology."
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">
                        <h1><span className="s1"><strong>Used 2015 Mercedes-Benz CLA45 For Sale In Boerne, Texas at Mark Motors</strong></span></h1>
                        <p><span>The used 2015 Mercedes-Benz CLA45 AMG for sale in Boerne, Texas at Mark Motors sits at the top of its family of exceptional builds - the used 2015 Mercedes-Benz CLA45, CLA45 4MATIC, and CLA45 AMG - and brings you exceptional power, style, and technology. With a turbocharged 2.0 engine that delivers you 355 horsepower, the used 2015 Mercedes-Benz CLA45 AMG for sale in Boerne, Texas lets you own the road like never before. Fulfill your style with a wide selection of bold, elegant exterior color options that include Jupiter Red, Cirrus White, Night Black, Cosmos Black Metallic, Northern Lights Violet Metallic, Polar Silver Metallic, Mountain Grey Metallic, Cocoa Brown Metallic, and Magno Polar Silver Matte. Test drive your used 2015 Mercedes-Benz CLA45 AMG for sale in Boerne, Texas at Mark Motors!</span>
                        </p>
                        <h2><span className="s1"><strong>Overview - 2015 Mercedes-Benz CLA45 For Sale Near Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Engine</strong></span>
                            <span>2.0 I-4 Engine</span>
                            <span>355 HP @ 6000 rpm</span>
                            <span>332 @ 2,250 rpm Torque</span>
                            <span>&nbsp;</span>
                            <span><strong>Transmission</strong></span>
                            <span>7-Speed auto-shift manual w/OD and auto-manual</span>
                            <span>&nbsp;</span>
                            <span><strong>Drive Type</strong></span>
                            <span>All-Wheel Drive</span>
                            <span>&nbsp;</span>
                            <span><strong>Efficiency</strong></span>
                            <span>23 city / 31 hwy / 26 combined mpg</span>
                            <span>&nbsp;</span>
                            <span><strong>Wheelbase</strong></span>
                            <span>18-inch Alloy Wheels</span>
                            <span><strong>&nbsp;</strong></span>
                            <h2><span className="s1"><strong>Engine Specs - 2015 Mercedes-Benz CLA45 Dealer In Boerne, Texas</strong></span></h2>
                            <span><strong>&nbsp;</strong></span>
                            <span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Gasoline Direct Injection.</span>
                            <span>Electronic Ignition Type.</span>
                            <span>Intercooled Turbo.</span>
                            <span>Aluminum Cylinder Block.</span>
                            <span>355 hp @ 6,000 rpm.</span>
                            <span>Variable Valve Control.</span>
                            <span>14.8 Fuel Tank Capacity.</span>
                            <span>Aluminum Cylinder Head.</span>
                            <span>332 lbs.-ft @ 2,250 rpm Torque.</span>
                            <span>16 Valves.</span>
                            <span>Transverse Engine Orientation.</span>
                            <span>2.0 Engine Liters.</span>
                            <span>I-4 Cylinder Configuration.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA45 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Exterior Features - 2015 Mercedes-Benz CLA45 Dealer In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Available Power Remote Right-Side View Door Mirror with Tilt Down.</span>
                            <span>Body-Colored Door Handles.</span>
                            <span>Fully Galvanized Steel Body Material.</span>
                            <span>Available Auto Dimming Power Remote Left Side-View Door Mirror.</span>
                            <span>Available Spoiler.</span>
                            <span>Metal-Look Bar Grille.</span>
                            <span>Power Remote Heated Folding Side-View Door Mirrors with Turn Signal Indicator.</span>
                            <span>Turn Signal Indicator Mirrors.</span>
                            <span>Heated Door Mirrors.</span>
                            <span>Available Metallic Paint.</span>
                            <span>Power Door Mirrors.</span>
                            <span>4 Doors.</span>
                            <span>Trunk Rear Cargo.</span>
                            <span>Body-Colored Front and Rear Bumpers.</span>
                            <span>Available Rear Lip Spoiler.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA45 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Interior Features - 2015 Mercedes-Benz CLA45 Specials In Boerne, Texas</strong></span></h2>
                        <p><span><strong>&nbsp;</strong></span>
                            <span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;<item attributes="{&quot;type&quot;: &quot;widget-image&quot;, &quot;src&quot;: &quot;https://cdn-ds.com/media/websites/3161/content/LP/2016-mercedes-cla45-4.jpg?s=149412&quot;, &quot;naturalWidth&quot;: 0, &quot;naturalHeight&quot;: 0, &quot;alt&quot;: &quot;Used 2015 Mercedes-Benz CLA45 For Sale In Boerne, Texas at Mark Motors&quot;}" type="widget-image"></item></span>
                            <span><strong>Convenience</strong></span>
                            <span>Available Cruise Control with DISTRONIC PLUS Distance Pacing.</span>
                            <span>Available Distance Pacing Cruise Control.</span>
                            <span>Door Mirror Memory.</span>
                            <span>2 Seatback Storage Pockets.</span>
                            <span>3 12V DC Power Outlets.</span>
                            <span>Emergency Communication System.</span>
                            <span>Power Windows with Front and Rear 1-Touch Down.</span>
                            <span>Driver Manual Folding Mirror.</span>
                            <span>Power Cargo Access Remote Release.</span>
                            <span>Available Sunshade.</span>
                            <span>Integrated Key/Remote.</span>
                            <span>Read Door Bins.</span>
                            <span>Available Panoramic Sunroof.</span>
                            <span>Air Filter.</span>
                            <span>Day-Night Rearview Mirror.</span>
                            <span>Available Garage Door Transmitter.</span>
                            <span>Keyfob (all doors) Remote Keyless Entry.</span>
                            <span>Full Floor Console.</span>
                            <span>Driver and Passenger Door Bins.</span>
                            <span>Found Dual Zone A/C.</span>
                            <span>Available Navigation System with Voice Activation.</span>
                            <span>Automatic Temperature Control.</span>
                            <span>Retained Accessory Power.</span>
                            <span>Available Navigation System.</span>
                            <span>Available Front and Rear Express Open/Close Sliding and Tilting Glass Sunroof.</span>
                            <span>Rear Cupholders.</span>
                            <span>Proximity Key.</span>
                            <span>Cruise Control.</span>
                            <span>Illuminated Driver and Passenger-Side Visor Mirrors.</span>
                            <span>Remote Window Controls.</span>
                            <span>Available Remote Sunroof/Convertible Roof Controls.</span>
                            <span>Available Sunroof/Convertible roof FOB Controls.</span>
                            <span>3 Memory Settings.</span>
                            <span>Front Underseat Storage Tray.</span>
                            <span>Illuminated Entry.</span>
                            <span>Passenger Manual Folding Mirror.</span>
                            <span>Steering Wheel with Manual Tilting, Manual Telescoping.</span>
                            <span>Available Power Glass Tilting and Sliding Sunroof.</span>
                            <span>Overhead Console.</span>
                            <span>Illuminated Passenger Vanity Mirror.</span>
                            <span>Mini Overhead Console with Storage.</span>
                            <span>Air Conditioning.</span>
                            <span>1-Touch Down.</span>
                            <span>Available Sport Steering Wheel with Manual Tilting, Manual Telescoping.</span>
                            <span>Keyfob Trunk/Hatch/Door Release.</span>
                            <span>Illuminated Driver Vanity Mirror.</span>
                            <span>Trunk/Hatch/Door FOB Controls.</span>
                            <span>Front and Rear Cupholders.</span>
                            <span>Console Ducts.</span>
                            <span>Available Power Sunshade.</span>
                            <span>Full Floor Console with Covered Box.</span>
                            <span>1-Touch Up.</span>
                            <span>Driver’s Footrest.</span>
                            <span>Auto-Locking Doors.</span>
                            <span>Automatic Dual-Zone Front Air Conditioning.</span>
                            <span>3 Driver and Passenger Memory Seat Settings (includes door mirrors).</span>
                            <span>Available Auto-Dimming Rearview Mirror.</span>
                            <span>Telescoping Steering Wheel.</span>
                            <span>Illuminated Glove Box.</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Seats and Trim</strong></span>
                            <span>8-Way Power Driver Seat.</span>
                            <span>Available Genuine Wood Instrument Panel Insert.</span>
                            <span>5 Max Seating Capacity.</span>
                            <span>Rear Seat Fold-Forward Setback.</span>
                            <span>Aluminum Instrument Panel Insert.</span>
                            <span>Carpet Front and Rear Floor Mats.</span>
                            <span>Power 4-Way Driver and Passenger Lumbar Support.</span>
                            <span>Available Driver and Passenger Heated-Cushions.</span>
                            <span>Passenger Cushion Tilt.</span>
                            <span>Floor Mats.</span>
                            <span>Metal-Look Interior Accents.</span>
                            <span>Driver Cushion Tilt.</span>
                            <span>Passenger Lumbar Support.</span>
                            <span>Cargo Light.</span>
                            <span>Front Center Armrest.</span>
                            <span>Available Carbon Fibre Instrument Panel Insert.</span>
                            <span>Power Driver and Passenger Fore/Aft Adjustment.</span>
                            <span>Available ARTICO Leatherette Door Panel Trim.</span>
                            <span>Cargo Tie-Downs.</span>
                            <span>Metal-Look Shift Knob.</span>
                            <span>DINAMICA/MB-Tex Simulated Suede/Leatherette Front and Rear Seat Upholstery.</span>
                            <span>Power Driver and Passenger Cushion Tilt.</span>
                            <span>Front Sport Seats.</span>
                            <span>Available Leather Dashboard.</span>
                            <span>Full Cloth Headliner.</span>
                            <span>Carpet Cargo Space.</span>
                            <span>8-Way Power Passenger Seat.</span>
                            <span>Concealed Cargo Storage.</span>
                            <span>Bucket Front Seats.</span>
                            <span>Height Adjustable Driver Seat.</span>
                            <span>Simulated Suede/Leatherette Upholstery.</span>
                            <span>Available MB-Tex Leatherette Door Panel Trim.</span>
                            <span>Driver Lumbar Support.</span>
                            <span>Available Leather Front and Rear Seat Upholstery.</span>
                            <span>Rear Bench Seat.</span>
                            <span>Carpet Trunk Lid/Rear Cargo Door.</span>
                            <span>Available Sport Steering Wheel.</span>
                            <span>Power Reclining Driver and Passenger Seats.</span>
                            <span>Rear Seat Center Armrest.</span>
                            <span>Rear 60-40 Bench Seat.</span>
                            <span>Carpet Floor Covering.</span>
                            <span>Available Alcantara Leather/Simulated Suede Steering Wheel.</span>
                            <span>5 Seating Capacity.</span>
                            <span>Height Adjustable Passenger Seat.</span>
                            <span>Rear Seat Center Armrest with Pass-Thru.</span>
                            <span>8-Way Driver and Passenger Seat Adjustments.</span>
                            <span>Leather/Metal-Look Steering Wheel.</span>
                            <span>Available Heated Front Seats.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA45 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Entertainment Features - 2015 Mercedes-Benz CLA45 Specials In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Primary Monitor Touchscreen.</span>
                            <span>Digital Signal Processor.</span>
                            <span>2 1st Row LCD Monitors.</span>
                            <span>Wireless Phone Connectivity.</span>
                            <span>Available SiriusXM AM/FM/HD/Satellite with Seek-Scan, Single In-Dash CD Player.</span>
                            <span>Audio Theft Deterrent.</span>
                            <span>AM/FM Radio.</span>
                            <span>8 Speakers.</span>
                            <span>Steering Wheel Mounted Audio Controls.</span>
                            <span>450W Amplifier.</span>
                            <span>Window Grid Antenna.</span>
                            <span>Internet Access.</span>
                            <span>CD Player.</span>
                            <span>Radio Data System.</span>
                            <span>Available 12 Harman/Kardon Speakers.</span>
                            <span>MP3 Decoder.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA45 vehicles for sale in Boerne, Texas.</span>
                            <span><strong>&nbsp;</strong></span>
                        </p>
                        <h2><span className="s1"><strong>Lighting &amp; Instrumentation - 2015 Mercedes-Benz CLA45 Dealer In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Low-Fuel Warning.</span>
                            <span>Fully Automatic Headlights.</span>
                            <span>Bulb-Failure Warning.</span>
                            <span>Available blind Spot Sensor.</span>
                            <span>Systems Monitor.</span>
                            <span>Low-Coolant Warning.</span>
                            <span>Automated Reverse Sensing System.</span>
                            <span>Front Reading Lights.</span>
                            <span>Light-Tinted Windows.</span>
                            <span>Outside-Temperature Display.</span>
                            <span>Trunk-Ajar Warning.</span>
                            <span>Dome Light with Fade.</span>
                            <span>Outside Temperature Display.</span>
                            <span>Variably Intermittent Wipers.</span>
                            <span>Rain Sensing Wipers.</span>
                            <span>Low-Oil-Level Warning.</span>
                            <span>Available Camera Rear.</span>
                            <span>Water Temp. Gauge.</span>
                            <span>Delay-Off Headlights.</span>
                            <span>Battery Warning.</span>
                            <span>Delay-Off Projector Beam Bi-Xenon High Intensity Low/High Beam Headlamps.</span>
                            <span>Available PARKTRONIC w/Active Parking Assist Automated Parking Sensors.</span>
                            <span>Available Camera - Rear.</span>
                            <span>Available Lane Departure.</span>
                            <span>Front and Rear Reading Lights.</span>
                            <span>Tire Specific Low-Tire-Pressure Warning.</span>
                            <span>Low-Washer-Fluid Warning.</span>
                            <span>Rear Rading Lights.</span>
                            <span>Brake-Fluid Warning.</span>
                            <span>Brake Pad Wear.</span>
                            <span>Rear Fog Lights.</span>
                            <span>Key-in-Ignition Warning.</span>
                            <span>Trip Computer.</span>
                            <span>Available Compass.</span>
                            <span>Lights-On Warning.</span>
                            <span>Variable Instrument Panel Lighting.</span>
                            <span>Trip Odometer.</span>
                            <span>Redundant Digital Speedometer.</span>
                            <span>Analog Display.</span>
                            <span>Rear Window Defroster.</span>
                            <span>Tachometer.’</span>
                            <span>In-Dash Clock.</span>
                            <span>Light Tinted Windows.</span>
                            <span>High Intensity Discharge Headlights.</span>
                            <span>Water-Temp. Warning.</span>
                            <span>Door-Ajar Warning.</span>
                            <span>4 Door Curb/Courtesy Lights.</span>
                            <span>Tire Pressure Sensors.</span>
                            <span>Heated Front Windshield Wiper Jets.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA45 vehicles for sale in Boerne, Texas.</span>
                            <span><strong>&nbsp;</strong></span>
                        </p>
                        <h2><span className="s1"><strong>Dimensions &amp; Capacity - 2015 Mercedes-Benz CLA45 For Sale In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Wheelbase: 106.3 in.</span>
                            <span>Front Legroom: 40.2 in.</span>
                            <span>Front Headroom: 38.2 in.</span>
                            <span>Maximum Interior Cargo Volume: 13.1 cu. ft.</span>
                            <span>Engine Horsepower: 355-hp @ 6000 rpm.</span>
                            <span>Interior Cargo Volume: 13.1 cu. ft.</span>
                            <span>Engine Bore x Stroke: 3.3 in. X 3.6 in.</span>
                            <span>Compression Ratio: 8.60 to 1.</span>
                            <span>Engine Type: I-4.</span>
                            <span>Payload: 1,080 lbs.</span>
                            <span>Valves: 16.</span>
                            <span>Front Shoulder Room: 56 in.</span>
                            <span>Front Tread: 61.3 in.</span>
                            <span>Ground Clearance (max): 3.9 in.</span>
                            <span>Fuel Economy Highway: 31 mpg.</span>
                            <span>Engine Torque: 332 lbs.-ft. @ 2,250 rpm.</span>
                            <span>Exterior Body Width: 70 in.</span>
                            <span>Drag Coefficient: .29</span>
                            <span>Turning Radius: 18.1 ft.</span>
                            <span>Rear Shoulder Room: 53.2 in.</span>
                            <span>Rear Legroom: 27.1 in.</span>
                            <span>Curb Weight: 3,494 lbs.</span>
                            <span>Fuel Tank Capacity: 14.8 gal.</span>
                            <span>Valve Train: DOHC.</span>
                            <span>Engine Displacement: 121 cu. in.</span>
                            <span>Exterior Length: 184.7 in.</span>
                            <span>Exterior Height: 55.7 in.</span>
                            <span>Rear Tread: 61.4 in.</span>
                            <span><strong>&nbsp;</strong></span>
                        </p>
                        <h2><span className="s1"><strong>Powerful, Elegant - 2015 Mercedes-Benz CLA45 In Boerne, Texas</strong></span></h2>
                        <img src={getImages('new/2016-mercedes-cla45-2.jpg')} alt='Used 2015 Mercedes-Benz CLA45 For Sale In Boerne, Texas at Mark Motors' />
                        <p><span>The used 2015 Mercedes-Benz CLA45 for sale in Boerne, Texas at Mark Motors showcases the most powerful 4-cylinder engine in production - a handcrafted AMG 355-HP Direct Injection Turbo-4. With a 7-speed AMG SPEEDSHIFT® DCT automatic transmission with shift paddles, the used 2015 Mercedes-Benz CLA45 for sale in Boerne, Texas lets you own the road like never before. Swing by Mark Motors and test drive your used 2015 Mercedes-Benz CLA45 for sale in Boerne, Texas!</span>
                            <span>Used 2015 Mercedes-Benz CLA45 for sale in Boerne, Texas.</span>
                            <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
                            <span>See dealer or owner's literature for limited warranty details.</span>
                            <span><strong>&nbsp;</strong></span>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Used2015MercedesBenzCla45ForSaleInBoerneTexas